'use strict';

const CouponsDFPAd = require('../../ads/views/coupons-dfp-ad');

const MIN_COUPONS_COUNT_FOR_TOP_AD = 1;
const MIN_INDEX_FOR_INLINE_AD = 5;
const MIN_INDEX_FOR_BOTTOM_AD = 10;

const adsConfig = {
  dfp_ad_top: {
    web: {
      outerClass: 'coupons-dfp-desktop',
      innerClass: 'ai-inventory-placement',
      innerId: 'ai-coupons-stores-desktop-728x90-toppage-0',
    },
  },
  dfp_ad_inline: {
    web: {
      outerClass: 'coupons-dfp-desktop',
      innerClass: 'ai-inventory-placement',
      innerId: 'ai-coupons-stores-desktop-728x90-inline-0',
    },
    touch: {
      outerClass: 'coupons-dfp-touch',
      innerId: 'ai-coupons-stores-touch-300x250-inline-0',
    },
  },
  dfp_ad_bottom: {
    web: {
      outerClass: 'coupons-dfp-desktop',
      innerClass: 'ai-inventory-placement',
      innerId: 'ai-coupons-stores-desktop-728x90-bottompage-0',
    },
    touch: {
      outerClass: 'coupons-dfp-touch',
      innerId: 'ai-coupons-stores-touch-300x250-bottompage-0',
    },
  },
  dfp_ad_left: {
    web: {
      outerClass: 'coupons-dfp-desktop',
      innerClass: 'dfp-belowlnav',
      innerId: 'ai-coupons-stores-desktop-160x600-belowlhnav-0',
    },
  },
};

function DFPAd({ adType, isTouch, index, couponsCount }) {
  if (
    (adType === 'dfp_ad_top' && couponsCount >= MIN_COUPONS_COUNT_FOR_TOP_AD) ||
    adType === 'dfp_ad_left' ||
    (adType === 'dfp_ad_inline' && index >= MIN_INDEX_FOR_INLINE_AD) ||
    (adType === 'dfp_ad_bottom' && index >= MIN_INDEX_FOR_BOTTOM_AD)
  ) {
    const dfpAdConfig = getAdsConfig(adType, isTouch ? 'touch' : 'web');
    if (dfpAdConfig) {
      return CouponsDFPAd(dfpAdConfig);
    }
  }
  return null;
}

function getAdsConfig(adType, platform) {
  if (adsConfig[adType] && adsConfig[adType][platform]) {
    return adsConfig[adType][platform];
  }
  return null;
}

module.exports = DFPAd;
